import { safeLocalStorage } from '@/js/lib/localStorage'
import languagePacks from '../../i18n'
import { CookieHelper } from '../services/cookieHelper'

export default (i18n) => {
  return {
    namespaced: true,
    state: {
      default: 'en-US',
      locale: i18n.locale,
      browser: window.navigator.userLanguage || window.navigator.language,
      override: safeLocalStorage.getItem('languageOverride'),
    },
    mutations: {
      setLocale(state, locale) {
        let orgUserLang = () => {
          const cookieData = CookieHelper('_pages_session=')
          if (cookieData && cookieData['language']) {
            return cookieData['language']
          }
          return null
        }
        // overload order
        // override from JWT with language key/value from org
        // override from localStorage
        // locale set from JWT
        // locale set from browser
        // default 'en-US'
        const currentLanguage =
          orgUserLang() ||
          state.override ||
          locale ||
          state.browser ||
          state.default

        if (!languagePacks[currentLanguage]) {
          console.warn(
            `Language (${currentLanguage}) isn't supported`,
            JSON.stringify(state),
          )
          return
        }

        return (state.locale = i18n.locale = currentLanguage)
      },
    },
  }
}
